import { capitalize } from '../../lib/string/lib';
import { SyncActionCreatorOptions } from '../types/Options';
import { SyncActionTypeValue } from './types';
import { SyncVerb } from '../types/Verbs';

export function createSyncActionTypeValue<SV extends SyncVerb, N extends string>(
	options: Omit<SyncActionCreatorOptions<SV, N>, 'hasRequest'>
): SyncActionTypeValue<SV, N> {
	const { syncVerb, name } = options;
	const syncVerbLowercased = syncVerb.toLowerCase();
	const nameCapitalized = capitalize(name);

	return `${syncVerbLowercased}${nameCapitalized}` as SyncActionTypeValue<SV, N>;
}
